import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }

import { watch , ref, inject } from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormSocietarioVerbaliDiAssemblea',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'modificaSocietaria':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaVerbaliDiAssemblea']['modificaSocietaria'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaVerbaliDiAssemblea']['modificaSocietaria'];
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaVerbaliDiAssemblea[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'societario/verbali_di_assemblea/' + props.tipoPreventivo.data.url
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true });
function modificaAlCapitale(event){
if(event.target.value == 'si'){
  validazione.valore.value = '';
  validazione.valore.required = true
} else {
  validazione.valore.value = '';
  validazione.valore.required = false
}
}
function inCasoDiImmobili(event){
  if(event.target.value != ''){
    validazione.numero_uffici_territorio.value = '1';
    validazione.numero_uffici_territorio.required = true;
  } else {
    validazione.numero_uffici_territorio.value = '0';
    validazione.numero_uffici_territorio.required = false;
  }
}
let indexHelperClosing = {
  calcolo: FormSocietarioHelper.sottocategoriaVerbaliDiAssemblea[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'modificaSocietaria')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).modifica_al_capitale.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.modifica_al_capitale.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "modifica_al_capitale",
                options: [{name: 'Sì', value: 'si'},{name: 'No', value: 'no'}],
                isSelected: _unref(validazione).modifica_al_capitale.value != '',
                onChange: _cache[0] || (_cache[0] = $event => (modificaAlCapitale($event))),
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).modifica_al_capitale,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).modifica_al_capitale) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(validazione).modifica_al_capitale.value == 'si')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_input_text, {
                    id: "valore",
                    name: "valore",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore,
                    "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).valore) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).modifica_al_capitale.value == 'si')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: [{name: 'Pubblico', value: 'pubblico'},
            {name: 'Privato', value: 'privato'}
            ],
                    isSelected: _unref(validazione).forma_del_titolo.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).in_caso_di_immobili.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.in_caso_di_immobili.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                state: __props.readonly == true ?'disable':'',
                name: "in_caso_di_immobili",
                options: [
                {name: 'Trascrizione e voltura', value: 'trascrizione_e_voltura'},
                {name: 'Voltura', value: 'voltura'}
                ],
                isSelected: _unref(validazione).in_caso_di_immobili.value != '',
                onChange: _cache[4] || (_cache[4] = $event => (inCasoDiImmobili($event))),
                validateTo: _unref(validazione).in_caso_di_immobili,
                "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).in_caso_di_immobili) = $event))
              }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
            ])
          ]),
          (_unref(validazione).in_caso_di_immobili.value != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(validazione).numero_uffici_territorio.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_uffici_territorio.ref]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_input_text, {
                    id: "numero_uffici_territorio",
                    name: "numero_uffici_territorio",
                    class: "placeholder-right crm:text-right",
                    placeholder: "Indicare numero uffici del territorio",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).numero_uffici_territorio,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).numero_uffici_territorio) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          (_unref(validazione).modifica_al_capitale.value === 'si')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 4,
                "input-riferimento-calcolo": "valore",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).modifica_al_capitale.value === 'no')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 5,
                "input-riferimento-calcolo": "valore",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly,
                "filter-options-d": true
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}